import theme_icons from '../../icons.js';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { InspectorControls, RichText } = wp.blockEditor;
const { PanelBody, TextControl, SelectControl } = wp.components;

const formassembly = {
    title: 'Form Assembly Form',
    icon: theme_icons.greenheart,
    category: 'greenheart',
    attributes: {
        formId: {
            type: 'integer', // Store as integer
            default: 0
        },
        postId: {
            type: 'integer',
            default: 0
        },
        campaignId: {
            type: 'string',
            default: ''
        },
        programCategory: {
            type: 'string',
            default: ''
        },
        successMessage: {
            type: 'string',
            default: 'Thank you for submitting the form!'
        }
    },

    edit({ attributes, setAttributes }) {
        const { formId, postId, campaignId, programCategory, successMessage } = attributes;

        function handleInputChange(value, key) {
            const intValue = parseInt(value, 10);
            setAttributes({ [key]: isNaN(intValue) ? 0 : intValue });
        }

        return ([
            <InspectorControls>
                <PanelBody title={__('Form Assembly Form Settings')}>
                    <TextControl
                        label={__('Form ID')}
                        type="number"
                        value={formId}
                        onChange={(newFormId) => handleInputChange(newFormId, 'formId')}
                        min={1}
                    />

                    <p><strong>Campaign ID:</strong></p>
                    <TextControl
                        label={__('Campaign ID')}
                        type="text"
                        value={campaignId}
                        onChange={(newval) => { setAttributes({ campaignId: newval }) }}
                    />

                    <p><strong>Program Category</strong></p>
                    <SelectControl
                        value={programCategory}
                        options={[
                            { label: 'Select', value: '' },
                            { label: 'TEFL/TESOL Course', value: 'TEFL/TESOL Course' },
                            { label: 'High School Abroad', value: 'High School Abroad' },
                            { label: 'Volunteer Abroad', value: 'Volunteer Abroad' },
                            { label: 'Language School', value: 'Language School' },
                            { label: 'Teen Summer Language Camp', value: 'Teen Summer Language Camp' },
                            { label: 'Teach English in a Homestay', value: 'Teach English in a Homestay' },
                            { label: 'Group Programs', value: 'Group Programs' },
                            { label: 'Ambassador Program', value: 'Ambassador Program' },
                        ]}
                        onChange={(newCategory) => setAttributes({ programCategory: newCategory })}
                    />

                    <TextControl
                        label={__('Post ID')}
                        type="number"
                        value={postId}
                        onChange={(newPostId) => handleInputChange(newPostId, 'postId')}
                        min={1}
                    />
                </PanelBody>
            </InspectorControls>,
            <div className="rbt-formassembly">
                <div className="placeholder"><img style={{ maxWidth: "300px", border: "1px solid black" }} src="/wp-content/plugins/GreenheartBlockEngineTravel/assets/thumbs/formassembly.jpg" loading="lazy" alt="Placeholder" /></div>
                <p>Success Message:</p>
                <RichText
                    tagName="p"
                    value={successMessage}
                    onChange={(newval) => { setAttributes({ successMessage: newval }) }}
                    placeholder="Thank you for submitting the form!"
                />
            </div>
        ]);
    },

    save({ attributes }) {
        return null;
    }
};

registerBlockType('rbt/formassembly', formassembly);
export default formassembly;